var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"post-has-background-input",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.innerValue)},on:{"input":function($event){return _vm.$emit('input', $event.target.textContent)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }